/**
 * Maintained by Sandon.
 */
<template>
  <div
    class="sy-select"
    v-click-outside="{outside: _hideDropdown, inside: _showDropdown}">
    <magic-input
      ref="magicInput"
      :multiple="multiple"
      :disabled="disabled"
      :filterable="filterable"
      :fixHeight="fixHeight"
      :visible="visible"
      :selectedTagsMaxHeight="selectedTagsMaxHeight"
      :popperWidth="popperWidth"
      :filterPlaceholder="filterPlaceholder"
      :placeholder="placeholder"
      :text="firstNodeText"
      :completeText="firstNodeCompleteText"
      :size="size"
      :popperClass="popperClass"
      :disableTitle="false"
      :clearable="clearable"
      :frozen="frozen"
      @toggle="_toggleVisible"
      @clear="_singleClear"
      @filter="_filter"
      @blur="_emitBlur"
      @focus="_emitFocus"
      @popperWidth="_realPopperWidthUpdate">
      <el-tag
        v-for="option in selected"
        :key="option.value"
        :closable="!disabled && !option.disabled"
        @close="_del(option)"
        type="info"
        :size="size"
        disable-transitions>
        {{option.label}}
      </el-tag>
      <!-- :container-width="popoverWidth"-->
      <!-- :isSelected="_isSelected"-->
      <template slot="popper">
        <div 
          class="sy-select__filter-list-wrap"
          :style="{maxHeight: `${popperHeight}px`}">
          <filter-list
            :loading="loading"
            :filterKw="filterKw"
            :filter-method="wrappedFilterMethod"
            :items="items"
            :selectedKeySet="selectedKeySet"
            :multipleLimit="multipleLimit"
            :width="realPopperWidth"
            :loadingText="loadingText"
            :noDataText="noDataText"
            :useSuffixSlot="useSuffixSlot"
            :useEmptySlot="realUseEmptySlot"
            @item-click="_clickFilterItem">
            <template slot="suffix" slot-scope="scope">
              <slot name="suffix"></slot>
            </template>
            <template slot="empty" slot-scope="scope">
              <slot name="empty"></slot>
            </template>
          </filter-list>
        </div>
        <slot name="footer"></slot>
      </template>
    </magic-input>
    <slot></slot>
  </div>
</template>

<script>
  import i18n from './i18n'
  import MagicInput from '../../magic-input/index.vue'
  import clickOutside from '../../../../utils/click-outside'
  import FilterList from '../../filter-list/index.vue'
  import {genMap, arrayContentSame} from '../../../../utils/index'
  import { debounce } from 'lodash-es'
  import scrollbarPrettify from '../../../../directives/scrollbar-prettify'
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'sy-select',
    components: {MagicInput, FilterList},
    props: {
      // 选中的key，如果是单选则为单个key值，多选则为key的数组，同el-select
      value: {required: true},
      // 以 [{label, value, disabled}] 格式传入 options
      // 和 optionInstances（以sy-option形式使用） 只有一个生效，options 优先
      options: {type: Array, default: () => []},
      // 输入框的placeholder
      placeholder: {type: String, default: pageText.pleaseChoose},
      // 过滤搜索时，输入框的placeholder
      filterPlaceholder: {type: String, default: pageText.search},
      // 是否多选
      multiple: {type: Boolean, default: false},
      // 禁用, 不让用户进行操作
      disabled: {type: Boolean, default: false},
      // 下拉是否展示
      visible: {type: Boolean, default: false},
      // 是否可进行搜索，如果需要远程搜索，配合`remoteFilter`使用，如果不设置`remoteFilter`，则会走默认本地搜索逻辑；
      filterable: {type: Boolean, default: false},
      // 是否固定高度,固定高度时高度由 selectedTagsMaxHeight 指定
      fixHeight: {type: Boolean, default: true},
      // 选中项展示时，最大的高度，超长会显示滚动条
      selectedTagsMaxHeight: {type: Number, default: 110},
      // size大小
      size: {type: String, default: 'small'},
      // popperClass为浮层对应的类名
      popperClass: {type: String, default: ''},
      // 搜索函数
      filterMethod: {type: Function, default: null},
      // 远程搜索
      remoteMethod: {type: Function, default: null},
      // 是否必须有搜索词，当没有搜索词时，下拉不展开
      mustHaveQuery: {type: Boolean, default: false},
      // 是否加载中
      loading: {type: Boolean, default: false},
      // 是否可清空（只对单选）
      clearable: {type: Boolean, default: true},
      // popper 宽度
      popperWidth: {type: Number, default: 0},
      // dropdown height
      popperHeight: {type: Number, default: 280},
      // 多选时选中条目数限制,为 0 则不限制
      multipleLimit: {type: Number, default: 0},
      // 加载中时的提示文案, undefined 以使用底层默认值
      loadingText: {type: String, default: undefined},
      // 无数据时的提示文案, undefined 以使用底层默认值
      noDataText: {type: String, default: undefined},
      // 搜索时点选option之后是否自动清除搜索词（多选）
      clearFilter: {type: Boolean, default: false},
      // 是否使用 empty slot，这是prop不对外，只供filter-select组件使用
      // 业务代码直接使用sy-select，此值为undefined；被 filter-select 组件使用时，此值为true/false
      useEmptySlot: {type: Boolean | undefined, default: undefined},
      // 是否冻结，冻结时不会监听滚动事件而调整 popper 位置, popper 展开状态也将保持不变
      frozen: {type: Boolean, default: false}
    },
    directives: {
      'click-outside': clickOutside,
      scrollbarPrettify
    },
    provide () {
      return {
        'select': this
      }
    },
    data () {
      return {
        optionInstances: [], // 当前options，元素为option组件实例
        selected: [], // 选中值，元素为{value,label,disabled}形式
        selectedValue: this.value,
        filterKw: '',
        // visible: false, // 下拉是否展示
        realPopperWidth: this.popperWidth,
        items: [],
        wrappedFilterMethod: null, // 本地搜索和远程搜索都会使用filter-list的本地搜索来实现
        
        useSuffixSlot: false,
        realUseEmptySlot: false
      }
    },
    computed: {
      // 选中的第一个节点展示的文字
      firstNodeText: function () {
        return this.selected.length ? this.selected[0].label : ''
      },
      firstNodeCompleteText: function () {
        return this.selected.length ? this.selected[0].label : ''
      },
      selectedKeySet: function () {
        return new Set(this.selected.map(_ => _.value))
      }
    },
    watch: {
      value: function () {
        this.selectedValue = this.value
        let needUpdate = true
        if (this.multiple) {
          if (arrayContentSame(this.selectedValue, this.selected.map(_ => _.value))) {
            needUpdate = false
          }
        } else {
          if ((this.selected.length && this.selected[0].value === this.selectedValue) ||
            (!this.selected.length && !this.selectedValue)) {
            needUpdate = false
          }
        }
        needUpdate && this._initSelected()
      },
      optionInstances: function () {
        this._debounceOptionsChangeHandle()
      },
      options: function () {
        this._optionsChangeHandle()
      },
      selected: function () {
        if (this.multiple && this.$refs['magicInput']) {
          this.$refs['magicInput'].updateHeight()
          this.$nextTick(() => {
            this.$refs['magicInput'].updatePopper() // 选中tag变多=>input变高=>popper调整位置
          })
        }
      },
      filterKw: function () {
        if (this.filterKw && !this.visible) {
          this._showDropdown()
        }
      },
      useEmptySlot: function () {
        this.realUseEmptySlot =
          this.useEmptySlot === undefined
            ? !!this.$scopedSlots.empty
            : this.useEmptySlot
      }
      // visible: function () {
      //   console.log('visible change', this.visible)
      //   this.$emit('visible-change', this.visible)
      //   this.$emit('update:visible', this.visible)
      // }
    },
    created () {
      // console.log('in select created:', this.$slots, this.$scopedSlots, this.$scopedSlots.suffix)
      this._debounceOptionsChangeHandle = debounce(this._optionsChangeHandle.bind(this), 30)

      // 过滤
      if (this.remoteMethod) {
        // 为了模拟element select组件接口，远程搜索时会修改options，也就会生成新的filterCandidates，
        // 所以将filterCandidates返回，不需要filter-list内部再进行过滤
        this.wrappedFilterMethod = () => {
          return this.items
        }
      } else if (this.filterMethod) {
        // todo
      }
    },
    mounted () {
      // console.log('in select mounted:', this.$slots, this.$scopedSlots, this.useEmptySlot)
      this.useSuffixSlot = !!this.$scopedSlots.suffix
      this.realUseEmptySlot = 
        this.useEmptySlot === undefined 
          ? !!this.$scopedSlots.empty 
          : this.useEmptySlot
      // if (this.$refs['magicInput']) {
      //   this.popoverWidth = Math.max(this.popoverWidth,
      //     this.$refs['magicInput'].$el.getBoundingClientRect().width)
      // }
      this._debounceOptionsChangeHandle()
    },
    methods: {
      // 展示dropdown
      _showDropdown (force = false) {
        if (this.visible || this.disabled || (!force && this.frozen) ||
          (!force && this.filterable && this.mustHaveQuery && !this.filterKw)) return
        this.visible = true
        this.$emit('visible-change', true)
        this.$emit('update:visible', true)
      },
      // 隐藏dropdown
      _hideDropdown (force = false) {
        if (!this.visible || this.disabled || (!force && this.frozen)) return
        this.visible = false
        this.$refs['magicInput'] && this.$refs['magicInput'].clearFilter()
        this.$emit('visible-change', false)
        this.$emit('update:visible', false)
      },
      // toggle dropdown的显示/隐藏
      _toggleVisible (e) {
        if (this.visible) {
          this._hideDropdown()
          // 阻止由于clickoutside导致的展开
          e.stopPropagation()
        } else {
          this._showDropdown(true)
        }
      },
      // 基于value和options初始化selected
      _initSelected () {
        if (this.multiple) {
          if (!Array.isArray(this.selectedValue) || !this.selectedValue.length) {
            this.selected = []
            return
          }
          // 优先级从后先前
          // const arr = [].concat(this.initOptions, this.selected, this.options)
          const arr = [].concat(this.selected, this.options.length ? this.options : this.optionInstances)
          const optionsMap = genMap(arr, 'value')
          this.selected = this.selectedValue
            .map(value => optionsMap[value])
            .filter(option => !!option)
            .map(option => {
              return {
                value: option.value,
                label: option.label,
                disabled: option.disabled
              }
            })
        } else {
          // 优先级从前到后，不同于上面
          // const arr = [].concat(this.optionInstances, this.selected, this.options)
          const arr = [].concat(this.options.length ? this.options : this.optionInstances, this.selected)
          const option = arr.find(_ => _.value === this.selectedValue)
          this.selected = option
            ? [{label: option.label, value: option.value, disabled: option.disabled}]
            : []
        }
      },
      // 单选时，清空输入框
      _singleClear () {
        this.selected = []
        this._selectedChangeManual()
        this.$emit('clear')
      },
      // 点tag来删除
      _del (option) {
        const index = this.selected.findIndex(_ => _.value === option.value)
        if (index > -1) {
          this.selected.splice(index, 1)
          this._selectedChangeManual()
        }
      },
      // 判断是否在已选里面 todo remove
      // _isSelected (value) {
      //   if (this.multiple) {
      //     if (!Array.isArray(this.selectedValue)) return false
      //     return this.selectedValue.findIndex(_ => _ === value) > -1
      //   } else {
      //     return this.selectedValue === value
      //   }
      // },
      // option项被点击
      _clickFilterItem (item) {
        const value = item.key
        // todo 改成和移动端一样的逻辑
        const newSelected = {
          value: value,
          label: item.label,
          disabled: item.disabled
        }
        if (this.multiple) {
          const index = this.selected.findIndex(_ => _.value === value)
          index === -1 ? this.selected.push(newSelected) : this.selected.splice(index, 1)
        } else {
          this.selected = [newSelected]
        }

        this._selectedChangeManual()

        if (!this.multiple) {
          this._hideDropdown()
        } else if (this.clearFilter && this.filterKw.length) {
          this.$refs['magicInput']?.clearFilter()
          this.$refs['magicInput']?.focus()
        }
      },
      // 重新计算 items
      _optionsChangeHandle () {
        // 下拉项处理
        // todo 需要允许key 不同，这样不用拷贝一份列表，性能优化
        this.items = this.options.length 
          ? this.options.map(_ => ({
            key: _.value,
            label: _.label,
            disabled: _.disabled
          }))
          : this.optionInstances.map((option) => {
            return {
              key: option.value,
              label: option.label,
              disabled: option.disabled
            }
          })
        this.$nextTick(() => {
          this.$refs['magicInput'] && this.$refs['magicInput'].updatePopper() // 条目数变化，高度也会变化
        })

        // 必要时初始化选中项
        const notNeedInitSelected = (this.multiple && this.selectedValue.length === this.selected.length) 
          || (!this.multiple && (this.selected.length ? this.selected[0].value === this.selectedValue : !this.selectedValue))
        if (!notNeedInitSelected) {
          this._initSelected()
        }
      },
      // 交互导致的选中项(selected)改变
      _selectedChangeManual () {
        if (this.multiple) {
          this.selectedValue = this.selected.map(_ => _.value)
        } else {
          this.selectedValue = this.selected.length ? this.selected[0].value : null
        }
        // cloneDeep(this.selectedValue)
        const value = this.multiple ? [...this.selectedValue] : this.selectedValue
        this.$emit('input', value)
        this.$emit('change', value, this.selected.map(_ => {
          return {
            value: _.value,
            label: _.label,
            disabled: _.disabled
          }
        }))

        // 触发校验
        // el-form-item 的校验基于 input 的
        // 因为是hack的方式，所以有如下要求：el-form-item 的rule中必须trigger含有 'blur'
        // this.$el.querySelector('input').dispatchEvent(new Event('change')) // change 事件无效
        this.$el.querySelector('input').dispatchEvent(new Event('blur'))
      },
      // 过滤词变化
      _filter (filterKw) {
        // todo 按移动端优化
        this.filterKw = filterKw
        if (this.remoteMethod) {
          this.remoteMethod(this.filterKw)
        } else if (this.filterMethod) {
          this.filterMethod(this.filterKw)
        } else {
          // 默认过滤逻辑
          this.$nextTick(() => {
            this.$refs['magicInput'] && this.$refs['magicInput'].updatePopper()
          })
        }
      },
      // 抛出focus事件
      _emitFocus () {
        this.$emit('focus')
      },
      // 抛出blur事件
      _emitBlur () {
        this.$emit('blur')
      },
      _realPopperWidthUpdate (width) {
        this.realPopperWidth = width
      },
      // 增加option - 被option组件调用
      onOptionAdd (optionInstance) {
        this.optionInstances.push(optionInstance)
        this._debounceOptionsChangeHandle()
      },
      // 注销option - 被option组件调用
      onOptionDestroy (optionInstance) {
        const index = this.optionInstances.indexOf(optionInstance)
        if (index > -1) {
          this.optionInstances.splice(index, 1)
          this._debounceOptionsChangeHandle()
        }
      },
      // 更新options - 被option组件调用
      update () {
        this._debounceOptionsChangeHandle()
      },
      // // 对外接口 - 展开下拉
      // async open () {
      //   await this.$nextTick()
      //   this._showDropdown()
      // },
      // // 对外接口 - 收起下拉
      // close () {
      //   this._hideDropdown()
      // },
      // // 对外接口 - 下拉状态冻住，即保持当前下拉状态不再改变直到解冻
      // freeze () {
      //   this.frozen = true
      // },
      // // 对外接口 - 下拉状态解冻
      // unfreeze () {
      //   this.frozen = false
      // }
    }
  }
</script>

<style scoped>
  .sy-select{
    display: inline-block;
    width: 100%;
    min-width: 100px;
    line-height: 0;
  }
  .sy-select__filter-list-wrap{
    overflow: auto;
  }
</style>
